import { Attrs, MinzeElement, Reactive } from 'minze'

export interface LvcHeartIcon {
  dataSize?: string
}

export class LvcHeartIcon extends MinzeElement {
  attrs: Attrs = ['data-size']
  reactive: Reactive = [['iconSize', this.dataSize || '20']]

  static observedAttributes = ['data-size']

  onAttributeChange = (name: string) => {
    if (name === 'data-size') {
      this.iconSize = this.dataSize || '20'
    }
  }

  html = () => `
    <svg
      width="${this.dataSize || '20'}"
      height="${this.dataSize || '20'}"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.3296 16.75C11.7173 15.636 13.2098 14.2944 14.3925 12.9697C15.5301 11.8086 16.4581 10.4639 17.1365 8.99374C17.4251 8.35074 17.5449 7.64631 17.485 6.94549C17.425 6.24467 17.1872 5.57006 16.7935 4.98396C16.4277 4.45498 15.9379 4.02108 15.3658 3.71918C14.7937 3.41728 14.1562 3.25632 13.5075 3.25C12.7716 3.26921 12.0544 3.48295 11.4306 3.86893C10.8598 4.22211 10.3666 4.89731 10.0311 5.47181C9.64982 4.83979 9.10529 4.14357 8.42903 3.82902C7.70279 3.49122 7.01114 3.24691 6.22393 3.40227C5.36052 3.54045 4.43371 4.07711 3.79774 4.67002C3.16178 5.26293 2.72065 6.03063 2.53145 6.8738C2.41615 7.66805 2.62054 8.47529 3.10082 9.12252C3.7364 9.96051 4.42371 10.759 5.15881 11.5135L7.79991 14.3854C8.4602 15.2713 9.40978 16.1295 10.3296 16.75Z" stroke="#FF4600" stroke-width="1.5" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
